import React, { useState, useEffect, useRef } from 'react';

function formatDate(d) {
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yy = d.getFullYear();
  return `${dd}.${mm}.${yy}`;
}

function parseDate(str) {
  if (!str) return null;
  const parts = str.split(/[.\-\/]/).map(s => parseInt(s, 10));
  if (parts.length < 3) return null;
  const [d, m, y] = parts;
  const date = new Date(y, (m||1)-1, d||1);
  return isNaN(date.getTime()) ? null : date;
}

export default function DatePicker({ value, onSelect, onClose }) {
  const initial = parseDate(value) || new Date();
  const [cursor, setCursor] = useState(new Date(initial.getFullYear(), initial.getMonth(), 1));
  const ref = useRef(null);

  useEffect(() => {
    function onDoc(e) {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) {
        onClose && onClose();
      }
    }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [onClose]);

  const startOfMonth = new Date(cursor.getFullYear(), cursor.getMonth(), 1);
  const startWeekDay = startOfMonth.getDay();
  const daysInMonth = new Date(cursor.getFullYear(), cursor.getMonth()+1, 0).getDate();

  const pickDay = (day) => {
    const d = new Date(cursor.getFullYear(), cursor.getMonth(), day);
    onSelect(formatDate(d));
    onClose && onClose();
  };

  const prevMonth = () => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() - 1, 1));
  const nextMonth = () => setCursor(new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1));

  return (
    <div ref={ref} style={{
      position: 'absolute',
      right: 0,
      top: 'calc(100% + 8px)',
      zIndex: 60,
      minWidth: 260,
      padding: 12,
      borderRadius: 12,
      background: 'rgba(255,255,255,0.06)',
      color: 'white',
      boxShadow: '0 8px 30px rgba(2,6,23,0.6)',
      border: '1px solid rgba(255,255,255,0.08)',
      backdropFilter: 'blur(8px)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <button className="btn btn-ghost btn-sm" onClick={prevMonth} aria-label="Vorheriger Monat">‹</button>
        <div style={{ fontWeight: 600 }}>{cursor.toLocaleString(undefined, { month: 'long' })} {cursor.getFullYear()}</div>
        <button className="btn btn-ghost btn-sm" onClick={nextMonth} aria-label="Nächster Monat">›</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 6, fontSize: 13 }}>
        {['So','Mo','Di','Mi','Do','Fr','Sa'].map(d => (
          <div key={d} style={{ textAlign: 'center', opacity: 0.7 }}>{d}</div>
        ))}
        {Array.from({ length: startWeekDay }).map((_, i) => <div key={'e'+i}></div>)}
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const day = i + 1;
          return (
            <button key={day} onClick={() => pickDay(day)} style={{
              padding: '6px 4px',
              borderRadius: 8,
              background: 'transparent',
              color: 'inherit',
              border: 'none',
              cursor: 'pointer'
            }}>
              {day}
            </button>
          );
        })}
      </div>
    </div>
  );
}
